import { ComponentClassNames } from '../../util/classNames';
import { PaletteColor } from '../../util/colors';
import { getThemeFontSizeStyles, textColors } from '../../util/styles/fonts';
import { IRawStyle, ITheme, memoizeFunction, mergeStyleSets } from '../../util/styling';

import { FontWeight, TextColor, TextDecoration, TextSize } from './Text.types';

export interface TextClassNameProps {
  readonly backgroundColor?: PaletteColor;
  readonly className?: string;
  readonly color?: TextColor;
  readonly fontWeight?: FontWeight;
  readonly textDecoration?: TextDecoration;
  readonly italic?: boolean;
  readonly size?: TextSize;
  readonly theme: ITheme;
  readonly uppercase?: boolean;
}

type GetClassNames = (props: TextClassNameProps) => ComponentClassNames<'text'>;
export const getClassNames: GetClassNames = (props) =>
  getClassNamesMemoized(
    props.backgroundColor,
    props.className,
    props.color,
    props.fontWeight,
    props.italic,
    props.textDecoration,
    props.size,
    props.theme,
    props.uppercase
  );

const getClassNamesMemoized = memoizeFunction(
  (
    backgroundColor: TextClassNameProps['backgroundColor'],
    className: TextClassNameProps['className'],
    color: TextClassNameProps['color'],
    fontWeight: TextClassNameProps['fontWeight'],
    italic: TextClassNameProps['italic'],
    textDecoration: TextClassNameProps['textDecoration'],
    size: TextClassNameProps['size'],
    theme: TextClassNameProps['theme'],
    uppercase: TextClassNameProps['uppercase']
  ) => {
    const fontSizeStyles: IRawStyle = size ? getThemeFontSizeStyles(size, theme) : {};

    const iconSize = size ? fontSizeStyles.fontSize : undefined;
    const svgIconTopOffset = size === TextSize.XSmall || size === TextSize.Small ? 1 : undefined;

    return mergeStyleSets({
      text: [
        {
          backgroundColor: backgroundColor ? theme.palette[backgroundColor] : undefined,
          fontWeight,
          fontStyle: italic ? 'italic' : undefined,
          display: 'inline',
          textDecoration,
          textTransform: uppercase ? 'uppercase' : undefined,
          ...fontSizeStyles,
          color: color ? textColors(theme)[color] : undefined,
          selectors: {
            '.y-icon, .y-fluent-icon': {
              height: iconSize,
              width: iconSize,
              top: svgIconTopOffset,
            },
          },
        },
        className,
      ],
    });
  }
);
